import React from 'react';

const ORDER_STATUSES = [
  'Order Placed',
  'Order Received',
  'Under Manufacturing',
  'Packed',
  'Ready for Dispatch',
  'Dispatched',
  'Delivered',
];

const STATUS_ICONS = {
  'Order Placed': '📝',
  'Order Received': '✅',
  'Under Manufacturing': '🏭',
  'Packed': '📦',
  'Ready for Dispatch': '🚚',
  'Dispatched': '🛣️',
  'Delivered': '🎉',
};

const OrderTimeline = ({ currentStatus, statusHistory = [] }) => {
  const currentIndex = ORDER_STATUSES.indexOf(currentStatus);

  const getTimestamp = (status) => {
    const entry = statusHistory.find((h) => h.status === status);
    if (entry) {
      return new Date(entry.timestamp).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    }
    return '';
  };

  return (
    <div className="timeline">
      {ORDER_STATUSES.map((status, index) => {
        let stateClass = 'pending';
        if (index < currentIndex) stateClass = 'completed';
        if (index === currentIndex) stateClass = currentStatus === 'Delivered' ? 'completed' : 'active';

        return (
          <div key={status} className={`timeline-item ${stateClass}`}>
            <div className="timeline-dot" />
            <div className="timeline-content">
              <h4>
                {STATUS_ICONS[status]} {status}
              </h4>
              {stateClass !== 'pending' && (
                <p>{getTimestamp(status)}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OrderTimeline;
